import FormInput from 'components/forms/inputs/FormInput.vue'
import FormDatepicker from 'components/forms/inputs/FormDatepicker.vue'
import FormCheckbox from 'components/forms/inputs/FormCheckbox.vue'
import FormCurrency from 'components/forms/inputs/FormCurrency.vue'
import FormPercentage from 'components/forms/inputs/FormPercentage.vue'
import FormSelect from 'components/forms/inputs/FormSelect.vue'
import FormChecklist from 'components/forms/inputs/FormChecklist.vue'
import FormFilepathInput from 'components/forms/inputs/FormFilepathInput.vue'
import PageWrapper from './layouts/common/PageWrapper.vue'
import FormWrapper from 'components/forms/FormWrapper.vue'
import FormSection from 'components/forms/FormSection.vue'
import FormSectionTitle from 'components/forms/FormSectionTitle.vue'
import FormRow from 'components/forms/FormRow.vue'
import FormGroup from 'components/forms/FormGroup.vue'
import FormTooltip from 'components/forms/FormTooltip.vue'
import FormTooltipIcon from 'components/forms/FormTooltipIcon.vue'
import FormDialog from 'components/dialogs/FormDialog.vue'
import FormMenulist from 'src/components/forms/inputs/FormMenulist.vue'
import ActionButton from 'components/buttons/ActionButton.vue'
import ToggleButton from 'components/buttons/ToggleButton.vue'
import ToggleButtons from 'components/buttons/ToggleButtons.vue'
import YesNoNaButtons from 'components/buttons/YesNoNaButtons.vue'
import AppButton from 'components/buttons/AppButton.vue'
import AddButton from 'components/buttons/AddButton.vue'
import EditButton from 'components/buttons/EditButton.vue'
import SaveButton from 'components/buttons/SaveButton.vue'
import BackButton from 'components/buttons/BackButton.vue'
import ViewButton from 'components/buttons/ViewButton.vue'
import DeleteButton from 'components/buttons/DeleteButton.vue'
import Alert from 'components/alerts/Alert.vue'
import Timestamp from 'components/Timestamp.vue'
import Placeholder from 'components/Placeholder.vue'
import Subtitle from 'components/Subtitle.vue'
import ImageCarousel from 'components/carousel/ImageCarousel.vue'

/**
 * Common components that should be automounted on every page.
 * Only put very frequently used things here!
 */
export function automount(app) {
    app.component('page-wrapper', PageWrapper)
    app.component('form-wrapper', FormWrapper)
    app.component('form-section', FormSection)
    app.component('form-section-title', FormSectionTitle)
    app.component('form-row', FormRow)
    app.component('form-group', FormGroup)
    app.component('form-input', FormInput)
    app.component('form-filepath-input', FormFilepathInput)
    app.component('form-select', FormSelect)
    app.component('form-checkbox', FormCheckbox)
    app.component('form-currency', FormCurrency)
    app.component('form-percentage', FormPercentage)
    app.component('form-checklist', FormChecklist)
    app.component('form-datepicker', FormDatepicker)
    app.component('form-tooltip', FormTooltip)
    app.component('form-tooltip-icon', FormTooltipIcon)
    app.component('form-dialog', FormDialog)
    app.component('form-menulist', FormMenulist)
    app.component('action-button', ActionButton)
    app.component('toggle-button', ToggleButton)
    app.component('toggle-buttons', ToggleButtons)
    app.component('yes-no-na-buttons', YesNoNaButtons)
    app.component('app-button', AppButton)
    app.component('add-button', AddButton)
    app.component('edit-button', EditButton)
    app.component('back-button', BackButton)
    app.component('save-button', SaveButton)
    app.component('delete-button', DeleteButton)
    app.component('view-button', ViewButton)
    app.component('alert', Alert)
    app.component('timestamp', Timestamp)
    app.component('placeholder', Placeholder)
    app.component('subtitle', Subtitle)
    app.component('image-carousel', ImageCarousel)
}
